var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.previewContainer },
    [
      _vm.isBundleCategory(_vm.currentCategoryKey)
        ? [
            _vm.isStandaloneItemCategory(_vm.currentCategoryKey)
              ? _c("ItemPreview", {
                  attrs: {
                    item: _vm.standaloneItem,
                    "item-to-image-mapper": _vm.standaloneItemImageMapper
                  }
                })
              : _c("BundlePreview", {
                  attrs: {
                    items: _vm.selectedBundleItems,
                    "item-to-image-mapper": _vm.bundleItemImageMapper
                  }
                })
          ]
        : _vm.isBowlPartCategory(_vm.currentCategoryKey)
        ? _c("BundlePreview", {
            attrs: {
              items: _vm.mainItems,
              "item-to-image-mapper": _vm.bundleItemImageMapper
            }
          })
        : _vm.isBurgerPartCategory(_vm.currentCategoryKey)
        ? _c("BurgerPreview", { attrs: { items: _vm.mainItems } })
        : _c("ItemPreview", {
            attrs: {
              item: _vm.standaloneItem,
              "item-to-image-mapper": _vm.standaloneItemImageMapper
            }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/Preview/OrderPreview.vue?vue&type=template&id=4a0f1498&
// module id = null
// module chunks = 